"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeleteCanSpamSettingRequestStatus = exports.getUpdateCanSpamSettingRequestStatus = exports.getCreateCanSpamSettingRequestStatus = exports.getFetchCanSpamSettingsRequestStatus = exports.getCanSpamSettings = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var getCanSpamSettings = function getCanSpamSettings(state) {
  return state.modules.marketing.email.entities.canSpamSettings;
};

exports.getCanSpamSettings = getCanSpamSettings;
var getFetchCanSpamSettingsRequestStatus = (0, _getRequestStatus.default)(_actions.CanSpamSettingsActionTypes.FETCH_CAN_SPAM_SETTINGS);
exports.getFetchCanSpamSettingsRequestStatus = getFetchCanSpamSettingsRequestStatus;
var getCreateCanSpamSettingRequestStatus = (0, _getRequestStatus.default)(_actions.CanSpamSettingsActionTypes.CREATE_CAN_SPAM_SETTING);
exports.getCreateCanSpamSettingRequestStatus = getCreateCanSpamSettingRequestStatus;
var getUpdateCanSpamSettingRequestStatus = (0, _getRequestStatus.default)(_actions.CanSpamSettingsActionTypes.UPDATE_CAN_SPAM_SETTING);
exports.getUpdateCanSpamSettingRequestStatus = getUpdateCanSpamSettingRequestStatus;
var getDeleteCanSpamSettingRequestStatus = (0, _getRequestStatus.default)(_actions.CanSpamSettingsActionTypes.DELETE_CAN_SPAM_SETTING);
exports.getDeleteCanSpamSettingRequestStatus = getDeleteCanSpamSettingRequestStatus;